import { render, staticRenderFns } from "./PushApplications.vue?vue&type=template&id=2141674e&"
import script from "./PushApplications.vue?vue&type=script&lang=ts&"
export * from "./PushApplications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports